import { FC } from 'react';
import { tailwindOverride } from '@getsynapse/design-system';
import type { NavItem } from '../../types';
import { truncateText } from 'utils/formatters';
import { NAV_ITEM_LABEL_CHAR_LIMIT } from '../../constant';

interface NavItemContentProps {
  item: NavItem;
  hideIcon?: boolean;
  className?: string;
}

const NavItemContent: FC<NavItemContentProps> = ({
  item,
  hideIcon = false,
  className,
}) => {
  return (
    <div
      className={tailwindOverride(
        'flex items-center h-full gap-x-2 py-2',
        className
      )}
    >
      <img
        src={item.iconSrc}
        className={tailwindOverride(
          'text-neutral-white',
          'duration-75 ease-in',
          {
            'ml-2': !hideIcon,
            'ml-1': hideIcon,
          }
        )}
        style={{ height: '18px', width: '18px' }}
        alt='icon'
      />
      <span
        className={tailwindOverride(
          'flex-grow',
          'text-label',
          'text-neutral-white',
          'transition-all',
          'duration-75 ease-in',
          'delay-150 motion-safe',
          'inline',
          { hidden: hideIcon }
        )}
      >
        {truncateText(item.label, NAV_ITEM_LABEL_CHAR_LIMIT)}
      </span>
    </div>
  );
};

export default NavItemContent;
